export enum LanguageEnum {
	ENGLISH = 'en',
	RUSSIAN = 'ru',
}
